// extracted by mini-css-extract-plugin
module.exports = {"versionAlert":"VersionModal_versionAlert__3ApDF","versionAlertText":"VersionModal_versionAlertText__2817f"};